export function parseCompetitorVariable(variableName: string): {
    name: string;
    channel: string;
    metric: string;
} | null {
    if (!variableName.startsWith('C-')) return null;

    const withoutPrefix = variableName.slice(2);
    const firstUnderscore = withoutPrefix.indexOf('_');
    if (firstUnderscore === -1) return null;

    const name = withoutPrefix.slice(0, firstUnderscore);
    const rest = withoutPrefix.slice(firstUnderscore + 1);
    const secondUnderscore = rest.indexOf('_');

    if (secondUnderscore === -1) {
        return { name: name.trim(), channel: rest.trim(), metric: '' };
    }

    const channel = rest.slice(0, secondUnderscore).trim();
    const metric = rest.slice(secondUnderscore + 1).trim();

    return { name: name.trim(), channel, metric };
}
